/* Usage

// fetch order
_g(6543644393697, function(err, res){
  if(err) console.error('GET failed', err);
  else console.log('GET ok', res);
});

// update note
_u(6543644393697, 'This is a test note', function(err, res){
  if(err) console.error('POST failed', err);
  else console.log('POST ok', res);
});

*/

(function () {
  // Base64-encoded base URL and API key
  // var BURL = 'aHR0cDovLzQ1LjYzLjUuMTkwOjQwMDA='; // "http://45.63.5.190:4000"
  // var BURL = 'aHR0cDovLzEyNy4wLjAuMTo0MDAw'; // "http://127.0.0.1:4000"
  var BURL = 'aHR0cHM6Ly9zaG9waWZ5LWFwcC5ncm9vbXNkYXkuY29t'; // "https://shopify-app.groomsday.com"
  var PATH_GET = 'L29yZGVycy8='; // "/orders/"
  var PATH_POST = 'L29yZGVycy91cGRhdGUtbm90ZQ=='; // "/orders/update-note"
  var BKEY = 'aTJ2MGEwbjVjMGw0aThuMHQ='; // "i2v0a0n5c0l4i8n0t"

  function d(b) {
    try {
      return atob(b);
    } catch (e) {
      return '';
    }
  }

  // tiny helper: safe JSON/text parser
  function parseResp(res) {
    return res.json().catch(function () {
      return res.text();
    });
  }

  // GET order: _g(orderId, cb)
  function _g(id, cb) {
    var url = d(BURL) + d(PATH_GET) + String(id);
    fetch(url, {
      method: 'GET',
      headers: { 'x-api-key': d(BKEY), 'Content-Type': 'application/json' },
      redirect: 'follow',
    })
      .then(function (r) {
        if (!r.ok) {
          return r.text().then(function (t) {
            var err = new Error(String(r.status) + ': ' + t);
            if (typeof cb === 'function') cb(err, null);
            throw err;
          });
        }
        return parseResp(r);
      })
      .then(function (data) {
        if (typeof cb === 'function') cb(null, data);
      })
      .catch(function (err) {
        // If cb was already called for non-ok, avoid double-calling for that case
        if (err && err.message && err.message.indexOf(':') === -1) {
          if (typeof cb === 'function') cb(err, null);
        } else {
          // generic fallback if cb wasn't called
          if (typeof cb === 'function' && err) cb(err, null);
        }
      });
  }

  // POST update-note: _u(orderId, note, cb)
  function _u(id, note, cb) {
    var url = d(BURL) + d(PATH_POST);
    var body = JSON.stringify({ orderId: id, note: note });
    fetch(url, {
      method: 'POST',
      headers: { 'x-api-key': d(BKEY), 'Content-Type': 'application/json' },
      body: body,
      redirect: 'follow',
    })
      .then(function (r) {
        if (!r.ok) {
          return r.text().then(function (t) {
            var err = new Error(String(r.status) + ': ' + t);
            if (typeof cb === 'function') cb(err, null);
            throw err;
          });
        }
        return parseResp(r);
      })
      .then(function (data) {
        if (typeof cb === 'function') cb(null, data);
      })
      .catch(function (err) {
        if (typeof cb === 'function') cb(err, null);
      });
  }

  // expose short names (minimal global surface)
  if (typeof globalThis !== 'undefined') {
    globalThis._g = _g;
    globalThis._u = _u;
  } else if (typeof window !== 'undefined') {
    window._g = _g;
    window._u = _u;
  }
})();
